import React, { useState, useEffect, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Paper,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { faTrashAlt, faPlus, faTimes, faSave } from '@fortawesome/pro-regular-svg-icons';
import { InputText, InputSelect, AldgDataGrid } from '@aldridge/aldg-data-components';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { deleteDoc, onSnapshot, setDoc, doc, collection, query, where } from 'firebase/firestore';
import { useGridApiRef } from '@mui/x-data-grid-premium';
import { ToolTipIconButton } from '@aldridge/aldg-ui-components';
import { firestore } from '../../firebase';
import { UserContext } from '../../providers/UserProvider';
import { _CurrentForeman } from '../../_Recoil/atoms';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing(1)
  }
}));

const GroupsList = (props) => {
  const [ForemanGroup, setForemanGroup] = useState([]);
  const { history } = props;
  const CurrentForeman = useRecoilValue(_CurrentForeman);
  const mounted = useRef(null);
  const handleSelect = (c) => {
    if (CurrentForeman.value[0] === c.data.Foreman) {
      history.push(`/groups/${c.id}`);
    } else {
      toast.info('This is not your group member to modify.');
    }
  };
  const addNew = () => {
    if (CurrentForeman.value.length > 0)
      history.push(`/groups/new`);
    else
      toast.error('You must select a Manager before adding a group Member...');
  };

  const getRecords = () => {
    const colRefForemansGroup = (() => {
      let col = collection(firestore, 'Group-Manager');
      if (CurrentForeman.value.length > 0) col = query(col, where('data.Foreman', '==', CurrentForeman.value[0]));
      else col = undefined;
      return col;
    })();
    if (typeof colRefForemansGroup !== 'undefined') {
      onSnapshot(colRefForemansGroup, (snap) => {
        const rec = [];
        snap.forEach(d => rec.push(d.data()));
        if (mounted.current)
          setForemanGroup(rec);
      });
    } else if (mounted.current) {
      setForemanGroup([]);
    }
  };

  useEffect(() => {
    mounted.current = true;
    if (mounted.current)
      getRecords();
    return () => (mounted.current = false);
  }, [CurrentForeman]);

  const apiRef = useGridApiRef();
  const removeRecord = async () => {
    const selectedRows = apiRef.current.getSelectedRows();
    if (selectedRows.length === 0) {
      toast.error('You must select a group member to remove.');
      return;
    }
    // eslint-disable-next-line no-restricted-syntax
    selectedRows.forEach((row) => {
      // eslint-disable-next-line no-await-in-loop
      deleteDoc(doc(firestore, 'Group-Manager', row.id)).then(() => {
        toast.success(`Removed the group.`);
      });
    });
  };

  const columns = [
    {
      field: 'GroupName',
      headerName: 'Group Name',
      width: 200,
      valueGetter: (params) => params.row.data.GroupName || ''
    },
    {
      field: 'Status',
      headerName: 'Status',
      width: 200,
      valueGetter: (params) => params.row.data.Status || ''
    }
  ];

  return (
    <>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          margin: '16px 0'
        }}
      >
        <ToolTipIconButton title="Add New Group Member" onClick={addNew} icon={faPlus} />
        <ToolTipIconButton title="Remove Group Member" onClick={removeRecord} icon={faTrashAlt} color="error" />
      </div>
      <Grid container>
        <Grid item xs={12}>
          <AldgDataGrid
            checkboxSelection
            rows={ForemanGroup}
            columns={columns}
            onRowClick={(params) => handleSelect(params.row)}
            containerHeight="750px"
            apiRef={apiRef}
          />
        </Grid>
      </Grid>
    </>
  );
};
GroupsList.propTypes = {
  history: PropTypes.objectOf(PropTypes.any).isRequired
};
GroupsList.defaultProps = {};

const GroupListSelection = (props) => {
  // const classes = basicStyles();
  const customClasses = useStyles();
  const { history, match } = props;
  const user = useContext(UserContext);
  const CurrentForeman = useRecoilValue(_CurrentForeman);
  const mounted = useRef(null);
  const [record, setRecord] = useState({
    id: '',
    CreatedBy: '',
    CreatedDate: '',
    ModifiedBy: '',
    ModifiedDate: '',
    data: {
      JobNumber: '',
      Foreman: CurrentForeman.value[0] || '',
      ForemanDisplay: CurrentForeman.shortDisplay || '',
      GroupName: '',
      Status: 'Active'
    }
  });

  useEffect(() => {
    if (match.params.id === 'new') return;
    mounted.current = true;
    onSnapshot(doc(firestore, 'Group-Manager', match.params.id), (snap) => {
      if (snap.exists) {
        const r = snap.data();
        if (mounted.current)
          setRecord({ ...r });
      }
    });
    // eslint-disable-next-line consistent-return
    return () => (mounted.current = false);
  }, [match.params.id]);

  const onChange = (event, name, displayFromTypeahead) => {
    try {
      const id = name || event.target.name;
      const value = typeof name !== 'undefined' ? event : event.target.value;
      const changedRecord = { ...record };
      changedRecord.data[id] = value;
      if (typeof displayFromTypeahead !== 'undefined') {
        changedRecord.data[`${id}Display`] = displayFromTypeahead;
      }
      if (changedRecord.CreatedDate === '') {
        changedRecord.CreatedBy = user.email;
        changedRecord.CreatedDate = new Date().toJSON();
      }
      changedRecord.ModifiedBy = user.email;
      changedRecord.ModifiedDate = new Date().toJSON();
      setRecord(changedRecord);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const addGroupMember = () => {
    const savedRecord = JSON.parse(JSON.stringify(record));
    if (record.data.GroupName === '') {
      toast.error('You need to enter a group name.');
      return;
    }
    if (match.params.id === 'new') {
      const docRef = doc(collection(firestore, 'Group-Manager'));
      savedRecord.id = docRef.id;
      setDoc(docRef, savedRecord);
      // toast.success('group Member Added.');
    } else {
      setDoc(doc(firestore, 'Group-Manager', savedRecord.id), savedRecord, { merge: true });
    }
    toast.success(`Successfully added ${record.data.EmployeeDisplay}`);
    history.push('/groups');
  };
  const backToGroup = () => {
    history.push('/groups');
  };
  return (
    <div style={{ paddingTop: '16px' }}>
      <div style={{
        position: 'sticky', top: '-1px', left: 0, right: 0, width: '100%', padding: '8px', paddingRight: '0px', display: 'flex', justifyContent: 'flex-end', zIndex: 100
      }}
      >
        <ToolTipIconButton tooltipText="Add New Group" onClick={addGroupMember} icon={faSave} color='success' />
        <ToolTipIconButton tooltipText="Close Record" onClick={backToGroup} icon={faTimes} color='error' />

      </div>
      <Paper className={customClasses.paper}>
        <Grid container spacing={0}>
          <Grid item xs={12} style={{ marginBottom: '8px' }}>
            <InputText
              label="Group Name"
              name="GroupName"
              onChange={onChange}
              value={record.data.GroupName || ''}
            />
          </Grid>
          <InputSelect
            label="Status"
            name="Status"
            onChange={onChange}
            value={record.data.Status || ''}
            options={[{ value: 'Active', label: 'Active' },
            { value: 'Inactive', label: 'Inactive' }]}
          />
        </Grid>
      </Paper>

    </div>
  );
};

GroupListSelection.propTypes = {
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired
};
GroupListSelection.defaultProps = {};

export { GroupListSelection, GroupsList };
